import React, { useState } from 'react';
import Webcam from 'react-webcam';
import './weblivecapture.css';

import putObject from '../../utils/upload_ali';

const videoConstraints = {
	width: 1280,
	height: 720,
	facingMode: 'user'
};

const WebLiveCapture = ({ onSaveData }) => {
	const webcamRef = React.useRef(null);
	const [ image, setImage ] = useState('');

	//post请求 https://usa.imgkits.com/node-api/exam，参数为type和image
	const examFace = async (image) => {
		const response = await fetch('https://usa.imgkits.com/node-api/exam', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ type: 1, image }),
		});
		const data = await response.json();
		console.log(data);
		return data;
	}

	const checkFace = async (imageSrc) => {
		//imageSrc 为base64，需要转换为file
		const base64 = imageSrc.replace(/^data:image\/\w+;base64,/, '');
		const blob = new Blob([ new Uint8Array(atob(base64).split('').map((c) => c.charCodeAt(0))) ], { type: 'image/jpeg' });
		const file = new File([ blob ], 'test.jpeg', { type: 'image/jpeg' });
		const image = await putObject(file, 'exam_proctor_', 'californian');
		console.log('putObject', image);
		if (image.url) {
			const res = await examFace(image.url.replace('https', 'http'));
			console.log('examFace', res);
			// {
			// 	"success": true,
			// 	"data": {
			// 			"headers": {
			// 					"date": "Thu, 28 Mar 2024 07:43:34 GMT",
			// 					"content-type": "application/json;charset=utf-8",
			// 					"content-length": "341",
			// 					"connection": "keep-alive",
			// 					"keep-alive": "timeout=25",
			// 					"access-control-allow-origin": "*",
			// 					"access-control-expose-headers": "*",
			// 					"x-acs-request-id": "AC84A67A-646C-5B6D-B60A-ED9D3F2AF172",
			// 					"x-acs-trace-id": "b8d7028f2a846838e31aa46d372fb35c",
			// 					"etag": "3S4jx9vmU6Fg8uC7FH39YGw1"
			// 			},
			// 			"statusCode": 200,
			// 			"body": {
			// 					"data": {
			// 							"faceInfo": {
			// 									"completeness": 1,
			// 									"faceNumber": 2,
			// 									"pose": {
			// 											"pitch": -2.172792434692383,
			// 											"roll": -0.5280653238296509,
			// 											"yaw": -8.007612228393555
			// 									}
			// 							},
			// 							"personInfo": {
			// 									"cellPhone": {
			// 											"score": 0.12967900931835175,
			// 											"threshold": 0.6
			// 									},
			// 									"earPhone": {
			// 											"score": 0.767423152923584,
			// 											"threshold": 0.6
			// 									},
			// 									"personNumber": 2
			// 							}
			// 					},
			// 					"requestId": "AC84A67A-646C-5B6D-B60A-ED9D3F2AF172"
			// 			}
			// 	}
		  // }
			if (res.data && res.data.statusCode === 200) {
				const data = res.data.body.data;
				const { faceInfo, personInfo } = data;
				let isSaveData = false;
				let saveData = {};
				if (faceInfo.faceNumber == 0) {
					isSaveData = true;
					saveData.faceNumber = faceInfo.faceNumber;
				} else if (faceInfo.faceNumber > 1) {
					isSaveData = true;
					saveData.faceNumber = faceInfo.faceNumber;
				}

				if (faceInfo.pose.pitch > 20 || faceInfo.pose.pitch < -20) {
					isSaveData = true;
					saveData.pitch = faceInfo.pose.pitch;
				}
				if (faceInfo.pose.roll > 20 || faceInfo.pose.roll < -20) {
					isSaveData = true;
					saveData.roll = faceInfo.pose.roll;
				}
				if (faceInfo.pose.yaw > 20 || faceInfo.pose.yaw < -20) {
					isSaveData = true;
					saveData.yaw = faceInfo.pose.yaw;
				}
			
				if (personInfo.cellPhone.score > personInfo.cellPhone.threshold) {
					isSaveData = true;
					saveData.cellPhone = personInfo.cellPhone;
				} 
				if (personInfo.earPhone.score > personInfo.earPhone.threshold) {
					isSaveData = true;
					saveData.earPhone = personInfo.earPhone;
				}
				if (isSaveData) {
					saveData.type = 'candidate_testing';
					saveData.image = image.url;
					saveData.time = new Date().getTime();
					onSaveData(saveData);
				}
			}
		}
	}
	
	const capture = React.useCallback(
		() => {
			const imageSrc = webcamRef.current.getScreenshot();
			// setImage(imageSrc);
			// console.log('Captured', imageSrc);
			checkFace(imageSrc);
		},
		[ webcamRef ]
	);

	return (
		<React.Fragment>
			<Webcam
				audio={false}
				ref={webcamRef}
				screenshotFormat="image/jpeg"
				height={150}
				width={300}
				videoConstraints={videoConstraints}
			/>

			<button className="hide" onClick={capture}>
				Capture photo
			</button>
		</React.Fragment>
	);
};

export default WebLiveCapture;
